import { valibotResolver } from '@hookform/resolvers/valibot';
import { date, minValue, nonEmpty, object, pipe, string } from 'valibot';

export const SNOOZE_ACTION_ITEM_FIELDS = {
  DATE: 'date',
  DESCRIPTION: 'description',
};

export const schemaSnoozeActionItem = (currentFacilityDateTime: Date) =>
  valibotResolver(
    object({
      [SNOOZE_ACTION_ITEM_FIELDS.DATE]: pipe(
        date('This field is required.'),
        minValue(currentFacilityDateTime, 'Please select an available time'),
      ),
      [SNOOZE_ACTION_ITEM_FIELDS.DESCRIPTION]: pipe(string(), nonEmpty('This field is required.')),
    }),
  );

export const snoozeActionItemDefaultValue = {
  [SNOOZE_ACTION_ITEM_FIELDS.DATE]: '',
  [SNOOZE_ACTION_ITEM_FIELDS.DESCRIPTION]: '',
};
